module.exports = __webpack_public_path__ + "media/images/squadBet__playerPlaceholder-df6dd3529c22cdc50458c8eec2201f28.png";